import React from 'react';
import axios from 'axios';

export default function ListItem({ item, editUTMs }) {
  const { date, user, organization, group_name, utms, batch_id } = item;

  return (
    <div className="grid utm__list-items">
      <div className="grid__col-lg-3 u--display-flex u--align-items-center">
        {date}
      </div>
      <div className="grid__col-lg-2 u--display-flex u--align-items-center">
        {user}
      </div>
      <div className="grid__col-lg-1 u--display-flex u--align-items-center">
        {organization}
      </div>
      <div className="grid__col-lg-3 u--display-flex u--align-items-center">
        {group_name}
      </div>
      <div className="grid__col-lg-1 u--display-flex u--align-items-center">
        {utms}
      </div>
      <div className="grid__col-lg-1 u--display-flex u--align-items-center">
        <button
          className="utm__edit-btn btn "
          onClick={() => {
            editUTMs(item);
          }}
        >
          Edit
        </button>
      </div>
      <div className="grid__col-lg-1">
        <button className="utm__archive-btn btn">Archive</button>
      </div>
    </div>
  );
}
